module.exports = __webpack_public_path__ + "img/undraw_studying.f25f8967.svg";